import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../config/config.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { NavigationLink } from '../../interfaces/navigation-item.interface';
import { PopoverService } from '../../components/popover/popover.service';
import { Observable, of } from 'rxjs';
import { UserMenuComponent } from '../../components/user-menu/user-menu.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchModalComponent } from '../../components/search-modal/search-modal.component';
import { InfoUsuarioLogin } from 'src/app/models/login.model';
import { LoginService } from 'src/app/services/micros/login.service';

@Component({
  selector: 'vex-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnDestroy {
  usuarioEnSesion: InfoUsuarioLogin;

  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
  imageUrl$ = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  showCollapsePin$ = this.configService.config$.pipe(map(config => config.sidenav.showCollapsePin));
  userVisible$ = this.configService.config$.pipe(map(config => config.sidenav.user.visible));
  searchVisible$ = this.configService.config$.pipe(map(config => config.sidenav.search.visible));
  userData$ = this.authService.user$;

  userMenuOpen$: Observable<boolean> = of(false);

  items = this.navigationService.items;
  private intervalId: any;

  constructor(private navigationService: NavigationService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private readonly popoverService: PopoverService,
    private readonly dialog: MatDialog,
    private readonly authService: LoginService) { }

  ngOnInit() {
    this.getUserData();

    this.items = this.navigationService.items;

  }

  getUserData(){
    let intentos = 0;

    this.setMenu();

    if (!this.usuarioEnSesion) {
      this.intervalId = setInterval(() => {
        this.setMenu();
        intentos++;

        if (this.usuarioEnSesion || intentos > 40) {
          clearInterval(this.intervalId);
        }
      }, 50);
    }
  }

  setMenu() {
    this.usuarioEnSesion = JSON.parse(localStorage.getItem('usuario'));

    let menu = [];

    switch (this.usuarioEnSesion?.catTipoAuditoriaId) {
      case 1: //INTERNA
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Periodo',
                route: '/kanban-auditoria-periodo',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }, {
                type: 'link',
                label: 'Fiscalización',
                route: '/admin-aud-interna',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Visualización TimeLine',
                route: '/timeline',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Internas',
                route: '/metricas-internas',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          }

        ]
        break;

      case 2: //Líneas de Acción de Mejora
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Periodo',
                route: '/kanban-auditoria-periodo',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }, {
                type: 'dropdown',
                label: 'Control Interno',
                icon: 'mat:list',
                children: [
                  {
                    type: 'link',
                    label: 'Líneas de Acción de Mejora',
                    route: '/admin-aud-mejora-uno',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  }
                ]
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Visualización TimeLine Mejoras',
                route: '/timeline-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Mejora',
                route: '/metricas-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          }

        ]
        break;

      case 3: //MEJORA Visita y/o Intervención
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Periodo',
                route: '/kanban-auditoria-periodo',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }, {
                type: 'dropdown',
                label: 'Control Interno',
                icon: 'mat:list',
                children: [
                  {
                    type: 'link',
                    label: 'Visita y/o Intervención',
                    route: '/admin-aud-mejora-tres',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  }
                ]
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Visualización TimeLine Mejoras',
                route: '/timeline-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Mejora',
                route: '/metricas-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          }

        ]
        break;

      case 4: //SEGUIMIENTO
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Periodo',
                route: '/kanban-auditoria-periodo',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }, {
                type: 'link',
                label: 'Seguimiento',
                route: '/seguimiento',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Metricas Auditorias Seguimiento',
                route: '/metricas-seguimiento',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          }
        ]
        break;

      case 5: //TODAS LAS PANTALLAS
        menu = [
          {
            type: 'subheading',
            label: '',
            children: [
              {
                type: 'link',
                label: 'Inicio',
                route: '/',
                icon: 'mat:dashboard',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Catálogos',
            children: [
              {
                type: 'link',
                label: 'Dias feriados',
                route: '/dias-feriados',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
            ]
          },
          {
            type: 'subheading',
            label: 'Auditorias',
            children: [
              {
                type: 'link',
                label: 'Periodo',
                route: '/kanban-auditoria-periodo',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              }, {
                type: 'link',
                label: 'Fiscalización',
                route: '/admin-aud-interna',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'dropdown',
                label: 'Control Interno',
                icon: 'mat:list',
                children: [
                  {
                    type: 'link',
                    label: 'Líneas de Acción de Mejora',
                    route: '/admin-aud-mejora-uno',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  },
                  {
                    type: 'link',
                    label: 'Visita y/o Intervención',
                    route: '/admin-aud-mejora-tres',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  }
                ]
              }
              ,
              {
                type: 'link',
                label: 'Seguimiento',
                route: '/seguimiento',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'dropdown',
                label: 'Peticiones',
                icon: 'mat:list',
                children: [
                  {
                    type: 'link',
                    label: 'Función Pública',
                    route: '/funcion-publica-aud',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  },
                  {
                    type: 'link',
                    label: 'ASF',
                    route: '/peticiones-asf',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  },
                  {
                    type: 'link',
                    label: 'Transparencia',
                    route: '/peticiones-transparencia',
                    icon: 'mat:label_important',
                    routerLinkActiveOptions: { exact: true }
                  }
                ]
              }
            ]
          },
          {
            type: 'subheading',
            label: 'Reportes',
            children: [
              {
                type: 'link',
                label: 'Visualización TimeLine',
                route: '/timeline',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Visualización TimeLine Mejoras',
                route: '/timeline-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Supervisor',
                route: '/metricas-supervisor',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Internas',
                route: '/metricas-internas',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Mejora',
                route: '/metricas-mejora',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Auditorias Seguimiento',
                route: '/metricas-seguimiento',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Metricas Peticiones',
                route: '/metricas-peticiones',
                icon: 'mat:list',
                routerLinkActiveOptions: { exact: true }
              },

            ]
          }

        ]
        break;

    }
    this.navigationService.items = menu;
    this.items = this.navigationService.items;
  }


  collapseOpenSidenav() {
    this.layoutService.collapseOpenSidenav();
  }

  collapseCloseSidenav() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
  }

  trackByRoute(index: number, item: NavigationLink): string {
    return item.route;
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: UserMenuComponent,
        origin,
        offsetY: -8,
        width: origin.clientWidth,
        position: [
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSearch(): void {
    this.dialog.open(SearchModalComponent, {
      panelClass: 'vex-dialog-glossy',
      width: '100%',
      maxWidth: '600px'
    });
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
